import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from '../../data.service';
import { AppData } from '../../constants/app-data';
import { CommonService } from '../../services/common.service';
import{ UrlConstant } from '../../constants/url-constant';
import { GlobalConstant } from '../../constants/global-constant';

import { Slick } from 'ngx-slickjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  slickArrayLength = 3;
  //slickArray = new Array(3) ;
  slickArray = [{"imgUrl":"/assets/img/study/college-board-geo.jpg" , "infoText":"Better place to boost your skills", "cssClass":"text-color-top"}, 
  					{"imgUrl":"/assets/img/study/college-student-geo.jpg" , "infoText":"Better place to elevate your skills", "cssClass":"text-color-top4"},
  					{"imgUrl":"/assets/img/study/online-classes-Engnr.jpg" , "infoText":"Better place to estimate your skills", "cssClass":"text-color-top8"}
  					] ;
  
  config: Slick.Config = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      mouseWheelMove:false,
      dots: true,
     // dotsClass: "text-color-bottom",
      autoplay: true,
      autoplaySpeed: 2500 
    }

	getSlickArray(count: number) {
		return this.slickArray;
	}
  prepareSlickArray(count: number) {
    //let slickArray = new Array(count);
   // this.slickArray.push({"imgUrl":"/assets/img/study/college-board-geo.jpg" , "infoText":"Better place to boost your skills"} );
   //// this.slickArray.push({"imgUrl":"/assets/img/study/college-student-geo.jpg" , "infoText":"Better place to elevate your skills"});
   // this.slickArray.push({"imgUrl":"/assets/img/study/online-classes-Engnr.jpg" , "infoText":"Better place to estimate your skills"});
    //slickArray.push("/assets/img/study/online-classes-grp.jpg");
    //slickArray.push("/assets/img/study/online-classes-img.jpg");
    return this.slickArray;
  }

	products  = [];
	message = "";
	specialId = "";
	extractedCompanyId = -1;
	userLoggedIn = false;
  constructor(private router: Router, private routeParams: ActivatedRoute, public appData: AppData,
  			private commonService: CommonService, private dataService: DataService) { }

  ngOnInit(): void {
	  var sId = this.routeParams.snapshot.params[GlobalConstant.KEY_URL_PARAM_VENDOR_UNIQUE_ID];
	   //console.log('sid:'+sId + '     this.specialId:'+this.specialId );
	  
	  if(sId!=null && sId!=undefined && sId!=''){
		  this.specialId = sId;
		  this.extractedCompanyId = this.commonService.extractEnterpriseIdFromUniqueId(sId);
		  this.dataService.setToLocalStorage(GlobalConstant.KEY_LOCAL_STORAGE_VENDOR_UNIQUE_ID, sId);
	  } else {
		  this.dataService.removeFromLocalStorage(GlobalConstant.KEY_LOCAL_STORAGE_VENDOR_UNIQUE_ID);
	  }
	   this.appData.isAuthenticated.subscribe(autheticated => {
		   if(autheticated!=null && autheticated != undefined && autheticated == true)
		 		this.userLoggedIn = true;
		 	else
		 		this.userLoggedIn = false;
		 });
	  this.dataService.sendGetRequestWithTextResponse(UrlConstant.apiWsActive).subscribe((data: any)=>{
	      console.log(data);
	      this.message = data;
	    })
	    
	    //this.dataService.sendGetRequest().subscribe((data: any[])=>{
	  //    console.log(data);
	//      this.products = data;
//	    })
  }
  public logout(){
  	if(this.appData.userId === ""){
  		//console.log("Nobody logged In");
  		return;
  	} else {
  		//console.log(this.appData.userId + " logging Out");
  	}
  	this.dataService.logout("");
  	this.userLoggedIn = false;
  	/*var reqBody = {"userId": this.appData.userId};
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiLogout ,reqBody).subscribe((data: any)=>{
      //console.log(data);
      if("SUCCESS" === data.statusCode){
      		//this.appData.loginInvalid.next(true);
      		this.appData.userId = "";
      		this.appData.isAuthenticated.next(false);
      		this.appData.isLeftNavActive.next(false);
      		this.appData.leftNavMenuDrawer.subscribe(leftMenuDrawer=> leftMenuDrawer.close());
      		this.isAuthenticated = false;
      		this.dataService.removeApiKeyHeaderFromLocalStorage();
      		this.dataService.navigateToUrl('/home');
      }
    });*/
  }
	
}
